// extracted by mini-css-extract-plugin
module.exports = {"row":"history-module_row__35L1qveqEBmEAPHxItWDci","container":"history-module_container__3ghN1Y5yBUvofPHv3zjgpC"};